module.exports = __webpack_public_path__ + "static/media/Pic-0076.724248fe.jpg";